import React, { useState, useEffect } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "../../../../../../components/switch";
const ComparisonColumns = props => {

  const [comparisonColumns, updateComparisonColumns] = useState([]);
  const [disableSave, setDisable] = useState(true);

  useEffect(() => {

    updateComparisonColumns([...(props.comparisonColumns || [])]);
  }, [props.comparisonColumns]);

  function handleChange(e, ix) {
    let comparison = comparisonColumns[ix];
    comparison.isActive = e.target.checked;
    updateComparisonColumns([...comparisonColumns]);
    setDisable(false);
  };

  async function Save() {
    const payload = {
      comparisonColumns,
      clientID: props.companyId
    };
    await props.onSave(payload);
    setDisable(true);
  };

  return (
    <>

      <div className="reportList">

        <div className="tabPanel df align-items-center justify-content-between">
          {comparisonColumns &&
            (comparisonColumns.map((cm, i) => {
              return <div className="tabList df align-items-center justify-content-between">
                <div className="tabListTitle">
                  {cm.label}
                </div>
                <div className="tabSwitch">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          value={cm.isActive}
                          onChange={(e) => handleChange(e, i)}
                          name={cm.key}
                        />
                      }
                    />
                  </FormGroup>
                </div>
              </div>
            }))
          }
        </div>

        <div className="df align-items-end justify-content-between flex-row-reverse mt-4 mb-3">
          <button className="btn reportBtn" onClick={Save} disabled={disableSave}>Save</button>
        </div>

      </div>
    </>
  )

};

export default ComparisonColumns;
